// Real-time multiplayer WebSocket client for SmashUp.io.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function wsUrl() {
  const base = BACKEND.replace(/^http/, "ws");
  return `${base}/api/ws`;
}

export class NetworkClient {
  constructor() {
    this.ws = null;
    this.pid = null;
    this.connected = false;
    this.onInit = null;
    this.onSnap = null;
    this.onDestroy = null;
    this.onEnd = null;
    this.onKill = null;
    this.onChat = null;
    this.onClose = null;
  }
  connect(join) {
    return new Promise((resolve, reject) => {
      let settled = false;
      try { this.ws = new WebSocket(wsUrl()); }
      catch (e) { reject(e); return; }
      const timer = setTimeout(() => { if (!settled) { settled = true; reject(new Error("Connection timed out")); this.close(); } }, 8000);
      this.ws.onopen = () => {
        this.ws.send(JSON.stringify({ type: "join", ...join }));
        // Focus-independent keepalive so the socket survives even if the tab
        // is backgrounded (requestAnimationFrame — and thus state streaming — throttles).
        this._hb = setInterval(() => {
          if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify({ type: "ping" }));
        }, 10000);
      };
      this.ws.onmessage = (e) => {
        let m; try { m = JSON.parse(e.data); } catch { return; }
        if (m.type === "init") {
          this.pid = m.pid; this.connected = true;
          if (!settled) { settled = true; clearTimeout(timer); resolve(m); }
          this.onInit && this.onInit(m);
        } else if (m.type === "snap") this.onSnap && this.onSnap(m);
        else if (m.type === "destroy") this.onDestroy && this.onDestroy(m);
        else if (m.type === "end") this.onEnd && this.onEnd(m);
        else if (m.type === "kill") this.onKill && this.onKill(m);
        else if (m.type === "chat") this.onChat && this.onChat(m);
      };
      this.ws.onerror = () => { if (!settled) { settled = true; clearTimeout(timer); reject(new Error("Could not connect to match server")); } };
      this.ws.onclose = () => { this.connected = false; clearInterval(this._hb); this.onClose && this.onClose(); };
    });
  }
  sendState(s) { if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify({ type: "state", ...s })); }
  sendDestroy(o) { if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify({ type: "destroy", x: Math.round(o.x), y: Math.round(o.y), key: o.key })); }
  sendKill(victim) { if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify({ type: "kill", victim })); }
  sendChat(text) { if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify({ type: "chat", text })); }
  close() { try { clearInterval(this._hb); this.ws && this.ws.close(); } catch (e) { console.warn("WS close failed", e); } this.ws = null; }
}
